import {Box} from "@mui/system";
import styles from "../organizationMainStyles";

export default function NoDataView({description, style= {}}) {
    return(
        <Box sx={styles.sectionWrapper}>
            <Box sx={{...style, ...{fontSize: '16px'}}}>
                {description || `Please select an organization to view details`}
            </Box>
        </Box>
    )
}